import apiClient from './authService';

export function getMyBusinessProductsGrouped(businessId) {
  return apiClient
    .get(`/business/${businessId}/products-grouped/`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(
          error.response.data.message || 'Failed to fetch business products'
        );
      }

      throw new Error('Network error');
    });
}

export function buildUpdateBusinessProductFormData(data) {
  const formData = new FormData();

  formData.append('business_product_id', data.business_product_id);
  formData.append('business_id', data.business_id);
  formData.append('product_id', data.product_id);

  if (data.price !== '' && data.price !== null && data.price !== undefined) {
    formData.append('price', data.price);
  }

  if (
    data.original_price !== '' &&
    data.original_price !== null &&
    data.original_price !== undefined
  ) {
    formData.append('original_price', data.original_price);
  }

  if (
    data.sale_price !== '' &&
    data.sale_price !== null &&
    data.sale_price !== undefined
  ) {
    formData.append('sale_price', data.sale_price);
  }

  if (
    data.stock_quantity !== '' &&
    data.stock_quantity !== null &&
    data.stock_quantity !== undefined
  ) {
    formData.append('stock_quantity', data.stock_quantity);
  }

  if (data.stock_status) {
    formData.append('stock_status', data.stock_status);
  }

  formData.append('is_visible', data.is_visible ? 'true' : 'false');
  formData.append('is_featured', data.is_featured ? 'true' : 'false');

  if (data.custom_title && data.custom_title.trim() !== '') {
    formData.append('custom_title', data.custom_title);
  } else {
    formData.append('custom_title', '');
  }

  if (data.custom_image instanceof File) {
    formData.append('custom_image', data.custom_image);
  }

  return formData;
}

export function updateBusinessProduct(data) {
  const formData = buildUpdateBusinessProductFormData(data);

  return apiClient
    .patch('/business-products/update/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        throw new Error(
          error.response.data.message || 'Failed to update product'
        );
      }

      throw new Error('Network error');
    });
}